import { TranslationParams } from './types';

/*
 * Парсит строку типа "До конца подписки {{days}} оплатите {{ price }}"
 * Где {{ days }} и {{ price }} - становятся динамическими параметромами передаваемыми как объект 2 аргументом
 * params - {days: '11 дней', price: '10$'}
 * Нв выходе "До конца подписки 11 дней оплатите 10$"
 * */
export const templateEngine = (
  template: string,
  params: TranslationParams,
): string =>
  template.replace(/{{(.*?)}}/g, match =>
    params[match.split(/{{|}}/).filter(Boolean)[0]].toString(),
  );

/*
  Провращает строку тип "Do it regularly, *see your health trend* and make right discussions."
  На выходе "Do it regularly, <strong>see your health trend</strong> and make right discussions."
 */
export const richText = (value: string) => {
  const strongSymbol = '*';
  return (
    <>
      {value.split(strongSymbol).map((item, index) => {
        if (index % 2) return <strong key={item}>{item}</strong>;
        return item;
      })}
    </>
  );
};
